/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * Administration icon.
 */
export const ICON_CAPABILITY_ADMINISTRATION = (
  <svg fill="none" height="48" viewBox="0 0 48 48" width="48" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M34 21.815C34.68 21.815 35.34 21.895 36 21.995V14.975C36 13.375 35.06 11.935 33.6 11.315L22.6 6.515C21.58 6.075 20.42 6.075 19.4 6.515L8.4 11.315C6.94 11.955 6 13.395 6 14.975V22.175C6 31.255 12.4 39.755 21 41.815C22.1 41.555 23.16 41.175 24.2 40.715C22.82 38.755 22 36.375 22 33.815C22 27.195 27.38 21.815 34 21.815Z"
      fill="#1D9BE2"
    />
    <path
      d="M34 25.815C29.58 25.815 26 29.395 26 33.815C26 38.235 29.58 41.815 34 41.815C38.42 41.815 42 38.235 42 33.815C42 29.395 38.42 25.815 34 25.815ZM34 28.575C35.24 28.575 36.24 29.595 36.24 30.815C36.24 32.035 35.22 33.055 34 33.055C32.78 33.055 31.76 32.035 31.76 30.815C31.76 29.595 32.76 28.575 34 28.575ZM34 39.315C32.14 39.315 30.52 38.395 29.52 36.975C29.62 35.535 32.54 34.815 34 34.815C35.46 34.815 38.38 35.535 38.48 36.975C37.48 38.395 35.86 39.315 34 39.315Z"
      fill="#1D9BE2"
    />
  </svg>
);
